import { Box, Button, Flex } from '@chakra-ui/react';
import {
  ModalOrDragDrawerContent,
  ModalOrDrawer,
  ModalOrDrawerBody,
  ModalOrDrawerFooter,
  ModalOrDrawerHeader,
  ModalOrDrawerOverlay,
} from '@ui/components/ModalOrDrawer';
import { resetWhenRouterChange } from '@ui/utils/zustandMiddleware';
import React from 'react';
import { create } from 'zustand';

import LockVnoCard from '../Vno/LockVnoCard';
import { useVaultDetailDrawer } from '../Vno/ReservoirAndFountain';
import type { VaultType } from '../Vno/ReservoirAndFountain/types';

function LockVnoDrawer() {
  const onVaultDetailDrawerOpen = useVaultDetailDrawer((s) => s.onOpen);
  const { close, isOpen, selectedType, setSelectedType } =
    useLockVnoDrawerStore();

  return (
    <ModalOrDrawer
      placement="bottom"
      size="full"
      scrollBehavior="inside"
      isOpen={isOpen}
      onClose={() => close()}
    >
      <ModalOrDrawerOverlay />
      <ModalOrDragDrawerContent>
        <ModalOrDrawerHeader>Lock VNO</ModalOrDrawerHeader>
        <ModalOrDrawerBody>
          <Box mx="auto" textStyle="h3" maxW="311px" textAlign="center">
            Where do you want to lock your VNO?
          </Box>
          <Flex mt={8} mx="auto" flexDir="column">
            <LockVnoCard
              type="FOUNTAIN"
              onClick={() => setSelectedType('FOUNTAIN')}
              shadow={
                selectedType === 'FOUNTAIN' ? 'card.active' : 'card.normal'
              }
            />
            <LockVnoCard
              type="RESERVOIR"
              onClick={() => setSelectedType('RESERVOIR')}
              shadow={
                selectedType === 'RESERVOIR' ? 'card.active' : 'card.normal'
              }
            />
          </Flex>
        </ModalOrDrawerBody>
        <ModalOrDrawerFooter>
          <>
            <Button
              disabled={!selectedType}
              onClick={() => {
                onVaultDetailDrawerOpen(selectedType ?? 'FOUNTAIN');
                close();
              }}
            >
              Confirm
            </Button>
            <Button
              variant={{ base: 'link', desktop: 'primary' }}
              textAlign="center"
              onClick={close}
              mt="20px"
            >
              Cancel
            </Button>
          </>
        </ModalOrDrawerFooter>
      </ModalOrDragDrawerContent>
    </ModalOrDrawer>
  );
}

export type LockVnoDrawerStore = {
  isOpen: boolean;
  close: () => void;
  open: () => void;
  selectedType?: VaultType;
  setSelectedType: (selectedType?: VaultType) => void;
};

export const useLockVnoDrawerStore = create<LockVnoDrawerStore>(
  resetWhenRouterChange((set) => ({
    isOpen: false,
    close: () =>
      set(() => ({
        isOpen: false,
        selectedType: undefined,
      })),
    open: () =>
      set(() => ({
        isOpen: true,
      })),
    setSelectedType: (selectedType?: VaultType) =>
      set(() => ({ selectedType })),
  })),
);

export default LockVnoDrawer;
